import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DistributionList from './List';
import DistributePackage from './Detail';
import DistributePackageHistory from './History';

const Distribution: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={<DistributionList />}
      />
      <Route
        path=':id/distribute'
        element={<DistributePackage />}
      />
      <Route
        path=':id/history'
        element={<DistributePackageHistory />}
      />
      <Route
        path='*'
        element={<Navigate to='.' />}
      />
    </Routes>
  );
};

export default Distribution;
